import { Notification } from "components/notification/Notification";
import React, { useEffect, useState } from "react";

import { lazy } from "react";

import { useNavigate } from "react-router-dom";
import userRole from "constants/userRole";
// project import
import Loadable from "../components/Loadable";
import MinimalLayout from "../layout/MinimalLayout";
import MainLayout from "../layout/MainLayout";
import ChartDisplay from "pages/Chart/ChartDisplay";

// render - utilities
const Login = lazy(() => import("../pages/authentication/Login"));
const Register = lazy(() => import("../pages/authentication/Register"));
const Home = Loadable(lazy(() => import("../pages/home/home/home")));
const AllPests = Loadable(lazy(() => import("../pages/home/pests/AllPests")));
const Crops = Loadable(lazy(() => import("../pages/home/crops/Crops")));
const Weeds = Loadable(lazy(() => import("../pages/home/weeds/Weeds")));
const Chart = Loadable(lazy(() => import("../pages/Chart/ChartDisplay")));
const DatabaseQueryExecutor = Loadable(lazy(() => import("../pages/developer/DatabaseQueryExecutor")));
const PestImages = Loadable(
  lazy(() => import("../pages/home/image-page/PestImages"))
);
const WeatherStation = Loadable(
  lazy(() => import("../pages/weather/WeatherStations"))
);
const WeedImages = Loadable(
  lazy(() => import("../pages/home/image-page/WeedImages"))
);
const DiseaseImages = Loadable(
  lazy(() => import("../pages/home/image-page/DiseaseImages"))
);
const PestDescription = Loadable(
  lazy(() => import("../pages/home/pest-description/PestDescription"))
);
const WeedDescription = Loadable(
  lazy(() => import("../pages/home/weed-description/WeedDescription"))
);
const DiseaseDescription = Loadable(
  lazy(() => import("../pages/home/disease-description/DiseaseDescription"))
);
const AllDiseases = Loadable(
  lazy(() => import("../pages/home/diseases/AllDiseases"))
);
const CropsDisease = Loadable(
  lazy(() => import("../pages/home/crop-diseases/CropsDisease"))
);
const PdfManager = Loadable(
  lazy(() => import("../pages/pdf-manager/PdfManager"))
);
const Comments = Loadable(
  lazy(() => import("../components/comments/Comments"))
);
const ExampleComment = Loadable(
  lazy(() => import("../components/comments/ExampleComment"))
);
const NotFoundPage = Loadable(
  lazy(() => import("pages/home/not-found-page/NotFoundPage"))
);
const About = Loadable(lazy(() => import("pages/home/about/About")));
const DescriptionPage = Loadable(
  lazy(() => import("pages/home/crops/description-page/DescriptionPage"))
);
const ImageManager = Loadable(
  lazy(() => import("pages/image-manager/ImageManager"))
);
const ObservedPestPage = Loadable(
  lazy(() => import("pages/ObservedPest/ObservedPestPage"))
);

function PrivateRoute({ component: Component, ...rest }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [role, setRole] = useState();
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    setRole(user ? user.uRole : null);
    setIsEditable(
      role === userRole.ADMIN || role === userRole.MODERATOR ? true : false
    );

    // Redirect to home if user is not admin and hasn't been notified
    if (!isEditable) {
      navigate("/");
      Notification("warning", "Unauthorized", "");
    }
  }, [user, role]);

  // Render the component if user is authorized
  return isEditable ? <Component {...rest} /> : null;
}

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
  path: "/",
  element: <MainLayout app={'ipms'}/>,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "register",
      element: <Register />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/about",
      element: <About />,
    },

    {
      path: "/pest-crops",
      element: <Crops />,
    },
    {
      path: "/disease-crops",
      element: <CropsDisease />,
    },
    {
      path: "/disease-crops/:cropName/:cropId",
      element: <AllDiseases />,
    },
    {
      path: "/weeds",
      element: <Weeds />,
    },
    {
      path: "/pest-crops/:cropName/:cropId",
      element: <AllPests />,
    },
    {
      path: "/pest/weather-stations/:cropName/:cropId/:pestName/:pestId",
      element: <WeatherStation />,
    },
    // {
    //   path: "/pest/weather-stations/:cropName/:cropId/:pestName/:pestId/degree-days/:stationId",
    //   element: <Chart />,
    // },
    {
      path: "/pest/description/:cropName/:cropId/:pestName/:pestId",
      element: <PestDescription />,
    },
    {
      path: "/disease/description/:cropName/:cropId/:diseaseName/:diseaseId",
      element: <DiseaseDescription />,
    },
    {
      path: "/weed/description/:weedName/:weedId",
      element: <WeedDescription />,
    },
    {
      path: "/comments",
      element: <Comments />,
    },
    {
      path: "*",
      element: <NotFoundPage link={'/'}/>,
    },
    {
      path: "/:type/description/:title/:cropId/:cropName/:name/:Id",
      element: <DescriptionPage />,
    },
    {
      path: "/:type/description/:title/:name/:Id",
      element: <DescriptionPage />,
    },
    {
      path: "/pest/images/:cropName/:cropId/:pestName/:pestId",
      element: <PestImages />,
    },
    {
      path: "/disease/images/:cropName/:cropId/:diseaseName/:diseaseId",
      element: <DiseaseImages />,
    },
    {
      path: "/weed/images/:weedName/:weedId",
      element: <WeedImages />,
    },
    {
      path: "pdf-manager",
      element: <PdfManager />,
    },

    {
      path: "/image-manager",
      element: <ImageManager />,
    },
    {
      path: "/observed-pests",
      element: <ObservedPestPage />,
    },
    {
      path: "/developer",
      element: <DatabaseQueryExecutor />,
    },
    
  ],
};

export default MainRoutes;
